// 260805nrai: Safe Foundation Reveal open + PDFObject embed for attachment / AZ PDF icons.
// Attachments/_list.html.erb had this locally; /azs and employee AZ tab did not → empty modal
// or Foundation open() crashing with "Cannot read properties of null (reading 'defaultView')"
// when the modal lookup failed / ran on a detached node.
//
// 260810nrai: Safari keeps the native PDF iframe at a tiny zoom after the reveal is hidden
// and shown again. Clear the embed on close so every show gets a fresh FitV instance.
//
// 260812nrai: Do not embed during fadeAndPop startup (modal still display:none for ~125ms).
// Cached PDFs init instantly at height 0 → thumb-size even on first open. Wait until the
// container has a real size, then embed with explicit px dimensions.

(function () {
  // Supersede in-flight size polls when the same modal is opened again quickly.
  var embedGenerationByModalId = {};
  var officePreviewInFlightByModalId = {};

  function modalIdFromEl(el) {
    if (!el || !el.getAttribute) return null;
    return el.getAttribute('data-reveal-id');
  }

  function closestRevealTrigger(start) {
    var el = start;
    while (el && el !== document) {
      if (el.getAttribute && el.getAttribute('data-reveal-id')) return el;
      el = el.parentNode;
    }
    return null;
  }

  function ensureRevealInitialized($modal) {
    if (!$modal.length) return;
    if (!$modal.data('reveal')) {
      try {
        $modal.foundation('reveal');
      } catch (e) {
        // ignore double-init races
      }
    }
  }

  function csrfToken() {
    if (window.Rails && typeof window.Rails.csrfToken === 'function') {
      return window.Rails.csrfToken();
    }
    var meta = document.querySelector('meta[name="csrf-token"]');
    return meta ? meta.getAttribute('content') : '';
  }

  function officePreviewUrl($container) {
    if (!$container || !$container.length) return null;
    return (
      $container.attr('data-office-preview-url') ||
      $container.data('officePreviewUrl') ||
      $container.data('office-preview-url') ||
      null
    );
  }

  function showOfficePreviewMessage($container, html) {
    if (!$container || !$container.length) return;
    $container.empty();
    $container.append(html);
  }

  function requestOfficePreviewThenEmbed($modal) {
    if (!$modal || !$modal.length || typeof jQuery === 'undefined') return;

    var $container = pdfContainer($modal);
    var convertUrl = officePreviewUrl($container);
    if (!convertUrl) return;

    var modalId = $modal.attr('id');
    if (!modalId || officePreviewInFlightByModalId[modalId]) return;
    officePreviewInFlightByModalId[modalId] = true;

    showOfficePreviewMessage(
      $container,
      "<p class='office-preview-status' style='padding:1em;'>Vorschau wird erzeugt …</p>"
    );

    fetch(convertUrl, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'X-CSRF-Token': csrfToken(),
        'X-Requested-With': 'XMLHttpRequest'
      },
      credentials: 'same-origin'
    })
      .then(function (res) {
        return res
          .json()
          .then(function (body) {
            return { ok: res.ok, body: body || {} };
          })
          .catch(function () {
            return { ok: false, body: {} };
          });
      })
      .then(function (result) {
        officePreviewInFlightByModalId[modalId] = false;
        var $current = jQuery('#' + modalId);
        if (!$current.length || !$current.is(':visible')) return;
        var $currentContainer = pdfContainer($current);
        if (!$currentContainer.length) return;

        if (result.body.pdf_url) {
          $currentContainer.attr('data-pdf-url', result.body.pdf_url);
          $currentContainer.removeAttr('data-office-preview-url');
          $currentContainer.removeData('officePreviewUrl');
          $currentContainer.empty();
          schedulePdfEmbed($current);
          return;
        }

        var downloadUrl = result.body.download_url;
        var message =
          result.body.error ||
          'Für dieses Office-Dokument ist keine Vorschau verfügbar.';
        var downloadHtml = downloadUrl
          ? " Bitte <a href='" +
            downloadUrl +
            "'>laden Sie das Dokument herunter</a>."
          : '';
        showOfficePreviewMessage(
          $currentContainer,
          '<h3>' + message + downloadHtml + '</h3>'
        );
      })
      .catch(function () {
        officePreviewInFlightByModalId[modalId] = false;
        var $current = jQuery('#' + modalId);
        if (!$current.length || !$current.is(':visible')) return;
        showOfficePreviewMessage(
          pdfContainer($current),
          '<h3>Für dieses Office-Dokument ist keine Vorschau verfügbar.</h3>'
        );
      });
  }

  function resolvePdfUrl($container) {
    var url =
      $container.attr('data-pdf-url') ||
      $container.data('pdfUrl') ||
      $container.data('pdf-url');
    if (url) return url;

    var containerId = $container.attr('id');
    if (!containerId || typeof jQuery === 'undefined') return null;

    var $trigger = jQuery('[data-pdf-target="' + containerId + '"]').first();
    if (!$trigger.length) return null;
    return (
      $trigger.attr('data-pdf-url') ||
      $trigger.data('pdfUrl') ||
      $trigger.data('pdf-url') ||
      null
    );
  }

  function pdfContainer($modal) {
    if (!$modal || !$modal.length) return jQuery();
    return $modal.find('[id^="pdf_container_"]').first();
  }

  function clearPdfEmbed($modal) {
    var $container = pdfContainer($modal);
    if ($container.length) $container.empty();
  }

  function containerHasLayoutSize(containerEl) {
    if (!containerEl) return false;
    return containerEl.clientWidth > 40 && containerEl.clientHeight > 40;
  }

  // height:100% can stay 0 until the reveal is display:block; borrow modal px if needed.
  function ensureContainerPixelSize($modal, $container) {
    var containerEl = $container[0];
    var modalEl = $modal[0];
    if (!containerEl || !modalEl) return;

    if (containerHasLayoutSize(containerEl)) return;

    var modalHeight = modalEl.clientHeight;
    var modalWidth = modalEl.clientWidth;
    if (modalHeight > 40) {
      $container.css('height', Math.floor(modalHeight) + 'px');
    }
    if (modalWidth > 40 && containerEl.clientWidth < 40) {
      $container.css('width', Math.floor(modalWidth) + 'px');
    }
  }

  function embedPdfNow($modal) {
    if (typeof PDFObject === 'undefined' || !$modal || !$modal.length) return false;

    var $container = pdfContainer($modal);
    if (!$container.length) return false;

    ensureContainerPixelSize($modal, $container);

    var containerEl = $container[0];
    if (!containerHasLayoutSize(containerEl)) return false;

    var containerId = $container.attr('id');
    var url = resolvePdfUrl($container);
    if (!url) return false;

    // Fresh iframe every show (Safari hide/show zoom bug).
    $container.empty();

    var widthPx = Math.floor(containerEl.clientWidth);
    var heightPx = Math.floor(containerEl.clientHeight);

    PDFObject.embed(url, '#' + containerId, {
      width: widthPx + 'px',
      height: heightPx + 'px',
      pdfOpenParams: { view: 'FitV', page: '1' },
      fallbackLink:
        "<p>PDF konnte nicht angezeigt werden. <a href='" +
        url +
        "'>Hier herunterladen</a>.</p>"
    });
    return true;
  }

  function schedulePdfEmbed($modal) {
    if (!$modal || !$modal.length || typeof jQuery === 'undefined') return;

    var modalId = $modal.attr('id');
    if (!modalId) return;
    if (!pdfContainer($modal).length) return;

    var generation = (embedGenerationByModalId[modalId] || 0) + 1;
    embedGenerationByModalId[modalId] = generation;

    function tryEmbed(attempt) {
      if (embedGenerationByModalId[modalId] !== generation) return;

      var $current = jQuery('#' + modalId);
      var $container = pdfContainer($current);
      if (!$container.length) return;

      if (!resolvePdfUrl($container) && officePreviewUrl($container)) {
        requestOfficePreviewThenEmbed($current);
        return;
      }

      // Already embedded for this open cycle (opened.* after a successful poll).
      if ($container.children().length > 0) return;

      if (embedPdfNow($current)) return;

      // fadeAndPop: display:block starts ~125ms; opened fires ~375ms. Poll until laid out.
      if (attempt < 30) {
        setTimeout(function () {
          tryEmbed(attempt + 1);
        }, 50);
      }
    }

    tryEmbed(0);
  }

  function openPdfReveal(triggerEl) {
    var modalId = modalIdFromEl(triggerEl);
    if (!modalId || typeof jQuery === 'undefined') return false;

    var $modal = jQuery('#' + modalId);
    if (!$modal.length) return false;

    var isPdfReveal =
      triggerEl.hasAttribute('data-pdf-url') ||
      (triggerEl.classList && triggerEl.classList.contains('pdf_trigger')) ||
      pdfContainer($modal).length > 0;
    if (!isPdfReveal) return false;

    ensureRevealInitialized($modal);
    // Drop any prior iframe before show — Safari otherwise keeps a broken zoom.
    clearPdfEmbed($modal);
    try {
      $modal.foundation('reveal', 'open');
    } catch (err) {
      if (typeof console !== 'undefined' && console.warn) {
        console.warn('badok PDF reveal open failed', modalId, err);
      }
    }

    // Size-gated embed (opened.* may not fire; polling covers animation startup).
    schedulePdfEmbed(jQuery('#' + modalId));

    return true;
  }

  function bindHandlers() {
    if (window.__badokAttachmentPdfRevealBound) return;
    window.__badokAttachmentPdfRevealBound = true;

    // Capture phase: run before Foundation's bubble handler (avoids defaultView crash).
    document.addEventListener(
      'click',
      function (e) {
        var trigger = closestRevealTrigger(e.target);
        if (!trigger) return;
        if (!openPdfReveal(trigger)) return;
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
      },
      true
    );

    if (typeof jQuery !== 'undefined') {
      // 260805nrai: must match Foundation's trigger namespaces exactly —
      // opened.fndtn.reveal.EXTRA does NOT fire for trigger('opened.fndtn.reveal').
      jQuery(document).on('opened.fndtn.reveal', function (e) {
        schedulePdfEmbed(jQuery(e.target));
      });
      jQuery(document).on('closed.fndtn.reveal', function (e) {
        var $modal = jQuery(e.target);
        var modalId = $modal.attr('id');
        if (modalId) {
          embedGenerationByModalId[modalId] =
            (embedGenerationByModalId[modalId] || 0) + 1;
          officePreviewInFlightByModalId[modalId] = false;
        }
        clearPdfEmbed($modal);
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bindHandlers);
  } else {
    bindHandlers();
  }
})();
